/*
 * Copyright 2025 coze-dev Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/** Aligned with uc007 constant/permission.js (subset for publish page). */
export const PERMISSION_ALL = '0';
export const PERMISSION_SELF_ONLY = '3';
export const PERMISSION_CURRENT_ORG = '1';
export const PERMISSION_CURRENT_ORG_AND_BELOW = '2';
export const PERMISSION_SPECIFIC_ORG = '4';

export type PublishScopeType =
  | typeof PERMISSION_ALL
  | typeof PERMISSION_SELF_ONLY
  | typeof PERMISSION_CURRENT_ORG
  | typeof PERMISSION_CURRENT_ORG_AND_BELOW
  | typeof PERMISSION_SPECIFIC_ORG
  | '';

export const PUBLISH_SCOPE_OPTIONS: Array<{
  value: PublishScopeType;
  labelKey: string;
}> = [
  { value: PERMISSION_ALL, labelKey: 'abr_publish_scope_all' },
  { value: PERMISSION_SELF_ONLY, labelKey: 'abr_publish_scope_self_only' },
  { value: PERMISSION_CURRENT_ORG, labelKey: 'abr_publish_scope_current_org' },
  {
    value: PERMISSION_CURRENT_ORG_AND_BELOW,
    labelKey: 'abr_publish_scope_current_org_below',
  },
  {
    value: PERMISSION_SPECIFIC_ORG,
    labelKey: 'abr_publish_scope_specific_org',
  },
];

export const SCOPE_SPECIFIC_ORG_EMPTY_MSG = '请设置指定组织';

export function isPublishScopeType(value: string): value is PublishScopeType {
  return (
    value === PERMISSION_ALL ||
    value === PERMISSION_SELF_ONLY ||
    value === PERMISSION_CURRENT_ORG ||
    value === PERMISSION_CURRENT_ORG_AND_BELOW ||
    value === PERMISSION_SPECIFIC_ORG ||
    value === ''
  );
}

export function getPublishScopeStoreTipKey(
  scopeType: PublishScopeType,
): string {
  if (scopeType === PERMISSION_ALL) {
    return 'abr_publish_scope_store_tip_all';
  }
  return 'abr_publish_scope_store_tip';
}
